var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-immunization-appointment.923b75ac.png","uri@2x": __webpack_public_path__ + "icon-immunization-appointment.b901f17a.png","uri@3x": __webpack_public_path__ + "icon-immunization-appointment.6275f815.png",
    width: 63,
    height: 60
});